import React from "react";
import { useForm } from "react-hook-form";
import DateSelector from "../../home/common/DateSelector";
import useTranslationHook from "../../hooks/useTranslationHook";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
    slot: yup
        .date()
        .nullable()
        .typeError("Please select date and time")
        .required("Please select date and time"),
});

const TimeSlotModal = ({ show, onClose, onHandleSubmit }) => {
    const { control, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: { slot: null },
    });

    const { t } = useTranslationHook();

    const onSubmit = async (data) => {
        onHandleSubmit?.(data);
        setValue("slot", null)
        onClose();
    };

    if (!show) return null;

    return (
        <>
            <div className="modal-backdrop fade show" />

            <div className="modal fade show d-block" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <form
                        className="modal-content"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {t("Select Preferred Time")}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                            />
                        </div>

                        <div className="modal-body">
                            <div className="datepicker">
                                <label className="form-label">
                                    {t("Date & Time")}
                                </label>

                                <DateSelector
                                    control={control}
                                    name="slot"
                                    placeholderText={t("Please select date and time")}
                                    dateFormat="dd-MM-yyyy h:mm aa"
                                    showTimeSelect
                                    timeIntervals={15}
                                    minDate={new Date()}
                                    className={`form-control ${errors.slot ? "is-invalid" : ""}`}
                                />

                                {errors.slot && (
                                    <small className="text-danger">
                                        {t(errors.slot.message)}
                                    </small>
                                )}
                            </div>
                        </div>

                        <div className="d-flex">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                {t("Cancel")}
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                            >
                                {t("Save Slot")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default TimeSlotModal;
